import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRACKERTYPE_LOAD,
    ACTION_TRACKERTYPE_LOAD_BY_ID,

    ACTION_TRACKERTYPE_SAVE,

    ACTION_TRACKERTYPE_CREATE,

    ACTION_TRACKERTYPE_VALIDATE,

    ITrackerTypeLoadAction,
    ITrackerTypeLoadByIdAction,
    ITrackerTypeLoadFailureAction,
    ITrackerTypeLoadSuccessAction,

    ITrackerTypeSaveAction,
    ITrackerTypeSaveSuccessAction,
    ITrackerTypeSaveFailureAction,

    ITrackerTypeCreateAction,
    ITrackerTypeCreateSuccessAction,
    ITrackerTypeCreateFailureAction,

    ITrackerTypeValidateAction,
    ITrackerTypeValidateSuccessAction,
    ITrackerTypeValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trackerTypes";
import { trackerTypeApi } from "../services/trackerType";

export const
    getTrackerTypesEpic = (action$): Observable<ITrackerTypeLoadSuccessAction | ITrackerTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRACKERTYPE_LOAD)
            .mergeMap((_action: ITrackerTypeLoadAction) => {
                return trackerTypeApi
                    .getTrackerTypes()
                    .map(response =>
                        LoadSuccess(response.trackerTypes, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrackerTypeByIdEpic = (action$): Observable<ITrackerTypeLoadSuccessAction | ITrackerTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRACKERTYPE_LOAD_BY_ID)
            .mergeMap((action: ITrackerTypeLoadByIdAction) => {
                return trackerTypeApi
                    .getTrackerTypeById(action.id)
                    .map(response =>
                        LoadSuccess(response.trackerType, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrackerTypeEpic = (action$): Observable<ITrackerTypeSaveSuccessAction | ITrackerTypeSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRACKERTYPE_SAVE)
            .mergeMap((action: ITrackerTypeSaveAction) => {
                return trackerTypeApi
                    .setTrackerType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trackerType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrackerTypeEpic = (action$): Observable<ITrackerTypeCreateSuccessAction | ITrackerTypeCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRACKERTYPE_CREATE)
            .mergeMap((_action: ITrackerTypeCreateAction) => {
                return trackerTypeApi
                    .createTrackerType()
                    .map(response =>
                        CreateSuccess(
                            response.trackerType,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrackerTypeEpic = (action$): Observable<ITrackerTypeValidateSuccessAction | ITrackerTypeValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRACKERTYPE_VALIDATE)
            .mergeMap((action: ITrackerTypeValidateAction) => {
                return trackerTypeApi
                    .validateTrackerType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trackerType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }